import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * SelectMaker
 */
class SelectMaker extends React.Component {

  constructor(props) {
    super(props);
    this.handleMakerClick = this.handleMakerClick.bind(this);
    this.handleMakerChange = this.handleMakerChange.bind(this);
  }

  // このボックスの表示データを取得
  componentDidMount() {

    // 機種名変更時(select2のchangeイベントをフック)
    const initialValue = commonLogic.getMakerFromURL();
    $('#selectMaker').off('change');
    $('#selectMaker').val(initialValue);
    $('#selectMaker').on('select2:select', (e) => {
      const value = e.params.data.id;
      this.handleMakerChange(value);
    });

    // 機種名リストクリック時
    $('#selectMaker').on('click', this.handleMakerClick);

    $('#selectMaker').on('select2:open', () => {
      const searchField = $('.select2-search__field');

      // クリアボタンがまだ存在しなければ追加
      if (!$('.clear-search').length) {
        searchField.after('<span class="clear-search">×</span>');
      }

      const clearButton = $('.clear-search');

      // クリアボタンがクリックされたら、検索フィールドをクリア
      clearButton.on('click', () => {
        searchField.val('').trigger('input').focus();
      });
    });
  }

  componentWillUnmount() {
    // イベントリスナーの解除
    $('#selectMaker').off('select2:open');
    $('.clear-search').off('click');
  }

  handleMakerChange(value) {
    this.props.actions.changeMaker(value);
  }

  handleMakerClick() {
    if ($('input').hasClass('select2-search__field')) {
      this.props.actions.stopUpdate();
    }
  }

  render() {
    // 表示データを取得
    const makerItemList = this.props.data.itemList.makerList;

    // 表示データを生成
    const nodes = makerItemList.map((item) => {
      return (
        <option value={item.id} key={item.id}>
          {item.display_name}
        </option>
      );
    });

    // すべて の選択肢を先頭に追加
    nodes.unshift(
      <option value={0} key={0}>
        すべて
      </option>
    );

    let selectedValue = 0;
    if (this.props.data.maker != null) {
      selectedValue = this.props.data.maker;
    }

    return (
      <div className="filter_item">
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
          <p>メーカー</p>
        </div>
        {/* {message} */}
        <label>
          <select id="selectMaker" value={selectedValue} readOnly>
            {nodes}
          </select>
        </label>
      </div>

    );
  }
}

SelectMaker.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectMaker;
